/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// eslint-disable-next-line no-restricted-modules
const $ = require('@trello/jquery');
const { getMilliseconds } = require('@trello/time');
const { rpcEvents } = require('app/scripts/network/rpc/rpcEvents');
const {
  currentModelManager,
} = require('app/scripts/controller/currentModelManager');

module.exports.SessionStatus = {
  start() {
    rpcEvents.on('ready', () => {
      return $(window).on('beforeunload', () => {
        this.markCurrentBoardAsViewed();
      });
    });

    const onUpdateOrDelete = ({ idModelChannel }) => {
      if (
        idModelChannel != null &&
        idModelChannel === currentModelManager.getCurrentBoard()?.id
      ) {
        this.scheduleMarkCurrentBoardAsViewed();
      }
    };

    rpcEvents.on('updateModels', onUpdateOrDelete);
    rpcEvents.on('deleteModels', onUpdateOrDelete);
  },

  markCurrentBoardAsViewed() {
    clearTimeout(this._markAsViewedTimeout);
    return currentModelManager.getCurrentBoard()?.markAsViewed();
  },

  scheduleMarkCurrentBoardAsViewed() {
    // We're depending on the fact that the timeout will be cleared on view changes,
    // so the timeout won't fire if the current board changes in the next minute.
    clearTimeout(this._markAsViewedTimeout);

    return (this._markAsViewedTimeout = setTimeout(
      () => this.markCurrentBoardAsViewed(),
      getMilliseconds({ minutes: 5 }),
    ));
  },
};
